import { Icon } from "@chakra-ui/react";
import React from "react";
import {
  FiBell,
  FiCalendar,
  FiCamera,
  FiFile,
  FiFolder,
  FiHeart,
  FiHome,
  FiImage,
  FiMail,
  FiMessageSquare,
  FiMusic,
  FiSend,
  FiSettings,
  FiStar,
  FiUser,
  FiVideo,
  FiBook,
  FiBox,
  FiGrid,
  FiKey,
} from "react-icons/fi";

const iconOptions = [
  { label: "Box", image: FiBox, value: "FiBox" },
  { label: "Key", image: FiKey, value: "FiKey" },
  { label: "Book", image: FiBook, value: "FiBook" },
  { label: "Grid", image: FiGrid, value: "FiGrid" },
  { label: "Home", image: FiHome, value: "FiHome" },
  { label: "Settings", image: FiSettings, value: "FiSettings" },
  { label: "User", image: FiUser, value: "FiUser" },
  { label: "Mail", image: FiMail, value: "FiMail" },
  { label: "Calendar", image: FiCalendar, value: "FiCalendar" },
  { label: "File", image: FiFile, value: "FiFile" },
  { label: "Folder", image: FiFolder, value: "FiFolder" },
  { label: "Image", image: FiImage, value: "FiImage" },
  { label: "Camera", image: FiCamera, value: "FiCamera" },
  { label: "Video", image: FiVideo, value: "FiVideo" },
  { label: "Music", image: FiMusic, value: "FiMusic" },
  { label: "Heart", image: FiHeart, value: "FiHeart" },
  { label: "Star", image: FiStar, value: "FiStar" },
  { label: "Bell", image: FiBell, value: "FiBell" },
  { label: "Message", image: FiMessageSquare, value: "FiMessageSquare" },
  { label: "Send", image: FiSend, value: "FiSend" },
];

export const getIcon = (icon?: string) =>
  iconOptions.find((o) => o.value === icon)?.image ?? FiBook;
